import React from 'react';
import { Route, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ReduxState } from '../../redux';
import { MAIN_ROUTES } from '../constants/RouteConstants';
import firebase from 'firebase';
import { getUserDetails, logoutUser } from '../../components/pages/LoginContainer/redux/slices/UserSlice';
import OnboardingFlowSequence from '../../components/containers/OnboardingFlowSequence';

interface IRedirectAuthRoute {
    Component: any;
    path: string;
    exact?: boolean;
}
export const InternalRouteGuard: React.FunctionComponent<IRedirectAuthRoute> = ({ Component, ...rest }) => {
    const render = (props: any) => {
        return <Component {...props} />;
    };
    return <Route {...rest} render={(props: any) => render(props)} />;
};

interface IAuthRoute {
    Component: any;
    path: string;
    exact?: boolean;
}

export const AuthRoute: React.FunctionComponent<IAuthRoute> = ({ Component, ...rest }) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const userObject = useSelector((state: ReduxState) => state.user.userData);
    React.useEffect(() => {
        const waitForFirebaseUser = async () => {
            const user = await new Promise((res) => {
                firebase.auth().onAuthStateChanged((u) => res(u));
            });
            if (!user || (!userObject.loading && !userObject.data && userObject.error)) {
                dispatch(logoutUser(userObject.error));
                history.replace(MAIN_ROUTES.login, { hideBanner: !!userObject.data });
            } else if (!userObject.loading && !userObject.data && !userObject.error) {
                dispatch(getUserDetails());
            }
        };
        waitForFirebaseUser();
    }, [userObject.loading]);

    return (
        <Route
            {...rest}
            render={(props) => (
                <OnboardingFlowSequence>
                    <Component {...props} />
                </OnboardingFlowSequence>
            )}
        />
    );
};
